import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { JobFileUploadPanel } from './JobFileUploadPanel';

// Uploading, as a modal rather than a panel that pushes the page around.
//
// The inline version had to earn its space twice: open, it shoved the folders
// and the grid down the page; closed, the Upload button looked like a toggle
// for something that had disappeared. A dialog is the honest shape — picking
// files is a task with a beginning and an end, not a mode the tab sits in.
//
// It closes as soon as files are accepted. The queue reports progress from the
// page itself (the desktop list, the phone's fixed dock), so holding the dialog
// open would only cover the thing the user wants to watch.

interface JobFileUploadDialogProps {
  open: boolean;
  onClose: () => void;
  /** Accepted files, already filtered by type. */
  onFiles: (files: File[]) => void;
  /** Where they will land, named so the destination is stated before the drop. */
  folderName?: string;
}

export function JobFileUploadDialog({
  open,
  onClose,
  onFiles,
  folderName,
}: JobFileUploadDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onClose()}>
      {open && (
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle>Upload files</DialogTitle>
            <DialogDescription>
              Images, PDFs and Office documents. They upload in the background, so you can carry on
              working.
            </DialogDescription>
          </DialogHeader>

          <div className="py-2">
            <JobFileUploadPanel
              onFiles={(files) => {
                onFiles(files);
                onClose();
              }}
              {...(folderName ? { folderName } : {})}
            />
          </div>
        </DialogContent>
      )}
    </Dialog>
  );
}
